(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["levano-article-click-tracking"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__levanoArticleClickV1) return;
  const configNode = document.getElementById('levano-article-click-config');
  const root = document.querySelector('.article__body');
  if (!configNode || !root || window.Shopify?.designMode) return;
  const path = decodeURIComponent(window.location.pathname).replace(/\/$/, '');
  const definitions = {
    '/blogs/ニュース/elevator-shoes-hard-to-walk-in': [
      ['walkability', 'walk_choice_sneaker', 'sneaker', 'choice_guide', 'シークレットスニーカー一覧を見る']
    ],
    '/blogs/ニュース/elevator-dress-shoes-for-suits': [
      ['suits', 'suits_after_table_business', 'business-elevator-shoes', 'after_comparison_table', 'ビジネス向けシークレットシューズ一覧']
    ],
    '/blogs/ニュース/how-many-cm-elevator-shoes-look-natural': [
      ['height_compare', 'height_intro_5cm', '5cm-up', 'opening_conclusion', '5cmアップのシークレットシューズ一覧'],
      ['height_compare', 'height_intro_6cm', '6cm-up', 'opening_conclusion', '6cmアップのシークレットシューズ一覧']
    ]
  };
  const definitionsForPage = definitions[path];
  if (!definitionsForPage) return;
  const preview = JSON.parse(configNode.textContent).preview === true;
  const targets = new Map();
  for (const definition of definitionsForPage) {
    const matches = Array.from(root.querySelectorAll('a[href]')).filter(anchor => {
      const url = new URL(anchor.href, window.location.origin);
      return url.origin === window.location.origin &&
        url.pathname.replace(/\/$/, '') === '/collections/' + definition[2] &&
        anchor.textContent.trim() === definition[4];
    });
    if (matches.length === 1) targets.set(matches[0], definition);
  }
  if (!targets.size) return;
  window.__levanoArticleClickV1 = true;
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  const handleClick = event => {
    if (!event.isTrusted || event.defaultPrevented || event.detail > 1) return;
    if (event.type === 'click' && event.button !== 0) return;
    if (event.type === 'auxclick' && event.button !== 1) return;
    const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null;
    const definition = targets.get(anchor);
    if (!definition) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
    if (typeof window.gtag !== 'function') {
      if (preview) console.warn('LEVANO article tracking: existing Google tag unavailable');
      return;
    }
    const [articleId, linkId, collectionHandle, linkPosition, linkText] = definition;
    const parameters = {
      send_to: 'G-6KMGKBHG37',
      article_id: articleId,
      link_id: linkId,
      collection_handle: collectionHandle,
      link_position: linkPosition,
      tracking_version: 'article_links_v1',
      page_path: path,
      link_url: window.location.origin + '/collections/' + collectionHandle,
      link_text: linkText
    };
    if (preview) parameters.debug_mode = true;
    window.gtag('event', 'article_collection_click', parameters);
  };
  root.addEventListener('click', handleClick);
  root.addEventListener('auxclick', handleClick);
})();
  } catch(e) { console.error(e); }
})();

})();
